import React, {useContext, useState} from 'react'

import PropTypes from 'prop-types'

import AtomButton, {atomButtonShapes} from '@s-ui/react-atom-button'
import SUIContext from '@s-ui/react-context'
import CardMarketedVersion from '@adv-mt/mt-card-marketed-version'
import IconAngleDown from '@adv-mt/mt-svg-icons/lib/ChevronDown.js'
import IconAngleUp from '@adv-mt/mt-svg-icons/lib/ChevronUp.js'

const BASE_CLASS = 'mt-ListMarketedVersions'

const BUTTON_DESIGN = 'solid'
const DEFAULT_VISIBLE_ITEMS = 10

const ROLE = 'marketed-version'
const BUTTON = 'marketed-versions-list-button'

const ListMarketedVersions = ({marketedVersions, linkFactory}) => {
  const {i18n} = useContext(SUIContext)

  const [isOpen, setIsOpen] = useState(false)

  const handleClick = () => setIsOpen(!isOpen)

  const collapsedMarketedversions = marketedVersions.slice(0, DEFAULT_VISIBLE_ITEMS)

  const visibleMarketedVersions = isOpen ? marketedVersions : collapsedMarketedversions

  const buttonText = isOpen ? i18n.t('COMMON_SHOW_LESS') : i18n.t('COMMON_SHOW_MORE')

  const icon = isOpen ? <IconAngleUp /> : <IconAngleDown />

  const hasLessOrEqualThanDefaultVisibleItems = marketedVersions.length <= DEFAULT_VISIBLE_ITEMS

  return (
    <div className={BASE_CLASS}>
      {visibleMarketedVersions.map(({price, initDate, endDate, url}, index) => {
        const props = {price, initDate, endDate, linkFactory, url}
        return <CardMarketedVersion key={index} {...props} role={ROLE} />
      })}
      {!hasLessOrEqualThanDefaultVisibleItems && (
        <AtomButton
          negative
          data-testid={BUTTON}
          design={BUTTON_DESIGN}
          onClick={handleClick}
          rightIcon={icon}
          fullWidth
          shape={atomButtonShapes.CIRCULAR}
        >
          {buttonText}
        </AtomButton>
      )}
    </div>
  )
}

ListMarketedVersions.displayName = 'ListMarketedVersions'
ListMarketedVersions.propTypes = {
  marketedVersions: PropTypes.arrayOf(
    PropTypes.shape({
      price: PropTypes.number.isRequired,
      initDate: PropTypes.string.isRequired,
      endDate: PropTypes.string,
      url: PropTypes.string.isRequired
    })
  ),
  linkFactory: PropTypes.func.isRequired
}

export default ListMarketedVersions
